import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StaticPagesService } from '../../shared/services/static-page/static-pages.service';
import { PageType } from '../../shared/models/enums/pageType';
import { RouterModule } from '@angular/router';
import { ImgViewComponent } from '../../shared/components/img-view/img-view.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-policies-kvkk',
  standalone: true,
  imports: [CommonModule, ImgViewComponent, RouterModule, FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './policies-kvkk.component.html',
  styleUrl: './policies-kvkk.component.scss',
})
export class PoliciesKvkkComponent implements OnInit {
  constructor(
    private staticPagesService: StaticPagesService,
    public router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  policies: any[] = [];

  ngOnInit(): void {
      this.getTermsAndConditions();
      this.getCancellationAndRefund();
      this.getClarificationText();
      this.getInformationText();
  }

  getTermsAndConditions() {
      this.staticPagesService.getByPageType(PageType.TermsAndConditions).subscribe((data) => {
        if (data && data.length > 0) {
          const policyData = data[0];
          this.policies[0] = policyData;
        }
      });
  }

  getCancellationAndRefund() {
      this.staticPagesService.getByPageType(PageType.CancellationAndRefund).subscribe((data) => {
        if (data && data.length > 0) {
          const policyData = data[0];
          this.policies[1] = policyData; 
        }
      });
  }

  getClarificationText() {
      this.staticPagesService.getByPageType(PageType.ClarificationText).subscribe((data) => {
        if (data && data.length > 0) {
          const policyData = data[0];
          this.policies[2] = policyData; 
        }
      });
  }

  getInformationText() {
      this.staticPagesService.getByPageType(PageType.InformationTextRegardingTheProcessingOfPersonalData).subscribe((data) => {
        if (data && data.length > 0) {
          const policyData = data[0];
          this.policies[3] = policyData; 
        }
      });
    }
  }
